import {
  GET_LOCALE_DATA_RECEIVED,
  GET_LOCALE_ERROR
} from "../services/coreDataService";

const initialState = {
  locale: "en_US",
  translation: {
    FOOTER: {
      COPYRIGHT_CONTENT:
        "Copyright © 2017 - 2018 Polycom, Inc. All rights reserved.",
      ADDRESS: "Address",
      PHONE: "Phone",
      EMAIL: "Email",
      LANGUAGE: "Language",
      TERMS_OF_SERVICE: "Terms of Service",
      PRIVACY_POLICY: "Privacy Policy"
    },
    DEVICE: {
      DEVICE: "Devices",
      TYPE: "Type",
      ROOM: "Room",
      STATUS: "Status",
      STATUS_ONLINE: "Online",
      STATUS_OFFLINE: "Offline",
      MAC: "MAC",
      ID: "ID",
      IP: "IP Address",
      ACTION: "Action",
      DEVICE_MANAGEMENT: "Device Management",
      TOTAL: "Total Devices",
      CONNECTED: "Connected Devices",
      NAME_DEVICE: "Name Your Device",
      NAME: "Device Name",
      PROMPT:
        "The device name will display for this device in the administration dashboards. We have automatically generated a unique name for your device. You can change the name at any time.",
      CHECK_PIN: "Failed to add the device. Enter the security code again.",
      PIN: "Security Code",
      PIN_REQUIRED: "Security Code is required.",
      PIN_INVALID: "Invalid Security Code.",
      DELETE: "Delete Device",
      FAILED_FIND: "Failed to find the device.",
      FAILED_DELETE: "Failed to delete the device.",
      FAILED_FETCH: "Failed to fetch devices.",
      NO_FOUND: "No device found.",
      EDIT: "Edit Device",
      FAILED_SAVE: "Failed to save changes.",
      SUCCESS_SAVE: "Succeed to save changes.",
      SUCCEED_DELETE: "Succeed to delete the device.",
      FAILED_LOAD_CONFIGURATION: "Unable to load device configurations.",
      OUT_OF_LENGTH: "Enter a device name with 40 characters or less.",
      DUPLICATE_ERROR:
        "Device name already exists. Enter a different device name.",
      REQUIRED: "Device name is required.",
      YOU_SURE: "Are you sure to delete this device?",
      REGISTER: "Register",
      ADD: "Add Device",
      REG_CODE: "Registration Code",
      REG_CODE_REQUIRED: "Registration code is required.",
      UPTIME: "Uptime",
      PHOLIO_REGISTER_ERROR:
        "Device registration failed - Invalid registration code.",
      PHOLIO_REGISTER_FORBIDDEN:
        "Failed to add device. Please check your Registration Code.",
      ADVANCED_SETTINGS: "Advanced Settings",
      DEVICE_CERTIFICATE: "Device Certificate (.PFX)",
      DEVICE_CERTIFICATE_PASSWORD: "Device Certificate Password",
      DEVICE_CERTIFICATE_STATUE: "Certificate Status",
      FAIL_UPLOAD: "Failed to upload the file.",
      SAVE_CONFIRM: "Are you sure to save without device certificate?",
      CERT_COLUMN_CN: "Common Name",
      CERT_COLUMN_VALID_PERIOD: "Validity Time"
    },
    LOCATION: {
      TOTAL: "Total Rooms",
      EXISTED: "Room name already exists. Enter a different room name.",
      REQUIRED: "Enter a room name.",
      PIN_ENABLED: "Security Code Required",
      PROMPT:
        "Note: Changes are updated when there are no active content sharing sessions in progress.",
      FAILED_FIND: "Failed to find the room.",
      FAILED_SAVE: "Failed to save changes.",
      DELETE: "Delete Room",
      FAILED_DELETE: "Failed to delete the room.",
      LOCATIONS: "Rooms",
      EDIT: "Edit room",
      NO_LOCATION: "No room found. Add a room.",
      FAILED_FETCH: "Failed to fetch rooms.",
      OUT_OF_LENGTH: "Enter a room name with 40 characters or less."
    },
    COMMON: {
      PORTAL_TITLE: "Polycom Cloud Service Administration",
      NAME: "Name",
      SHOW: "Show",
      SEARCH: "Search",
      ADD: "Add",
      EDIT: "Edit",
      REFRESH: "Refresh",
      DASHBOARD: "Dashboard",
      WAIT: "Please Wait...",
      NAME_REQUIRED: "A name is required.",
      PIN_REQUIRED: "Security Code Required",
      BACK: "Back",
      EXIT_PHOLIO: "Exit registration",
      PHOLIO_REGISTER_ERROR: "Failed to register to Polycom Cloud Service.",
      NEXT: "Next",
      REGREX: "Contains special characters.",
      SIZE: "Exceeds the maximum length of 40 characters",
      CANCEL: "Cancel",
      DELETING: "Deleting...",
      DELETE: "Delete",
      LOADING: "Loading...",
      ID: "ID",
      MAC_ID: "MAC ID",
      SERIAL_NUM: "Serial Number",
      IPV4: "IPv4",
      IPV6: "IPv6",
      SOFTWARE_VERSION: "Software Version",
      HARDWARE_VERSION: "Hardware Version",
      ROOM: "Room",
      TYPE: "Type",
      CONFIGURE: "Configure",
      AUTHENTICATION: "Authentication",
      FIELD_REQUIRED: "This field is required",
      REALM: "Realm",
      PROVIDER: "Provider",
      ACTION: "Action",
      BLANK: "Blank",
      CUSTOM: "Custom",
      FORMAT: "Format",
      CHANGE: "Change",
      TITLE: "Cloud Service Administration",
      SETTINGS: "Settings",
      INTEGRATION: "Integration",
      SAVE: "Save",
      SAVING: "Saving...",
      SIGN_IN: "Sign In",
      EMAIL_ID: "Email Address",
      CONTINUE: "Continue",
      TRUE: "Yes",
      FALSE: "No",
      COPY_CLIPBOARD: "Copy to Clipboard",
      SUCCESS: "Success",
      ERROR: "Error",
      SHOW_MENU: "Show Menu",
      HIDE_MENU: "Hide Menu",
      NOTICE: "Notice",
      HELP: "Polycom Cloud Service Administration Portal Help",
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      GO_HOME: "Back to home page",
      VERIFY: "Verify",
      HOME: "Home",
      UPLOAD: "Upload",
      OK: "OK",
      CONFIRM_TITLE: "Confirm",
      VALID: "Valid",
      INVALID: "Invalid"
    },
    REGISTER: {
      POLYCOM_TITLE: "Polycom<sup>&reg;</sup> Pano&trade;",
      SIGN_IN_NOTE:
        "Enter the email address associated with your Polycom Cloud Service Administration account.",
      REGISTERING: "Registering",
      INVALID_URI: "{{property}} in url is invalid.",
      FIRST_NAME_REQUIRED: "First name is required.",
      LAST_NAME_REQUIRED: "Last name is required.",
      EMAIL_REQUIRED: "Email is required.",
      PASSWORD_REQUIRED: "Password is required.",
      COMPANY_REQUIRED: "Company name is required.",
      COMPANY_NAME: "Company Name",
      PASSWORD: "Password",
      CAPTCHA: "Please enter the content in the image",
      CAPTCHA_REQUIRED: "Captcha is required.",
      NEXT: "Next",
      STEP: "Step",
      CREATE_ACCOUNT: "Create Account",
      WELCOME_1: "Creating your Polycom Cloud Service account",
      WELCOME_2:
        "To proceed, you must have a valid <strong>Polycom License Activation Key</strong>{{tip}}, which you received as part of purchasing a Polycom product or service. If you have not yet received your License Activation Key, please contact your sales representative. If you have not yet purchased a Polycom product or service, please contact a Polycom sales representative or visit {{link}} to learn about all of the products and services that Polycom has to offer.",
      WELCOME_3: "I have a valid Polycom License Activation Key.",
      REGISTER_1: "Please verify your email address.",
      REGISTER_2:
        "We have sent an email to {{email}} with a link to verify your email address. The link is valid for <strong style='color:#f04134'>24 hours</strong>.",
      RESEND:
        "If you do not receive this email message, please click {{link}} to resend it.",
      HERE: "here",
      RESENT:
        "Email successfully re-sent. You can send again in {{sec}} seconds.",
      ALREADY: "Already have an account?",
      TENANT_CREATED:
        "Domain exists. You cannot use the email domain to create new accounts.",
      DOMAIN_PROHIBIT:
        "You cannot use the email domain to create new accounts.",
      REGISTRATION_ALREADY:
        "You already used this email address to start registration. Registration email resent to this address.",
      ERROR: "Registration failed. Please contact the system administrator.",
      SUCCEED: "New account created. Please log in with your email address.",
      REGISTER_CONFIRM:
        "Are you sure you want to go to login page?<p/><p/>You have not completed the whole registration flow. You can continue this registration flow by clicking the link in your verification email.",
      ACTIVATION_TITLE: "Email Address Verified!<br/>Verify Activation Key",
      STEP0: "Start",
      STEP1: "Enter Account Information",
      STEP2: "Assign Password",
      STEP3: "Verify Email Address",
      STEP4: "Verify Activation Key",
      STEP5: "Finish"
    },
    ROOM: {
      NAMEROOM: "Name Your Room",
      NAME: "Room Name",
      REGREX: "Contains special characters.",
      SIZE: "Exceeds the maximum length of 40 characters.",
      PROMPT:
        "When users wish to connect with this Pano device, they will look for this name in services like AirPlay<sup>&reg;</sup>, Miracast<sup>&reg;</sup>, and when using Polycom<sup>&reg;</sup> Pano&#x2122 App. We recommend using the name of the room or space in which this device is found, such as the name of the conference room."
    },
    AUTHENTICATION: {
      PROVIDERS: "Authentication Providers",
      BUILDIN_PROVIDERS: "Built-in Authentication Providers",
      CUSTOM_PROVIDERS: "Custom Authentication Providers",
      CONFIGURATION: "Authentication Provider Configuration",
      FAILED_FIND: "Failed to find the provider.",
      FAILED_SAVE: "Failed to save changes.",
      FAILED_CREATE: "Failed to create new provider.",
      CLIENT_ID: "Client ID",
      CLIENT_SECRET: "Client Secret",
      CALLBACK_URL: "Callback URL",
      AUDIENCE: "Okta Domain",
      HOSTNAME: "Ping Host Name",
      REGION: "OneLogin Region",
      EU: "eu",
      US: "us",
      URL: "Authorization URL",
      TOKEN_URL: "Token URL",
      LOGOUT_REDIRECT_URL: "Logout redirect URL",
      RESOURCE: "Resource",
      REDIRECT_URL: "Redirect URL",
      FAILED_DELETE: "Failed to delete the provider.",
      NOT_FOUND: "No authentication provider found. Add a provider.",
      FAILED_FETCH: "Failed to fetch authentication provider.",
      TENANT: "Tenant",
      SUCCESS_EDIT: "Succeed to save changes.",
      SUCCESS_DELETE: "Succeed to delete the provider.",
      DEL_TITLE: "Delete Authentication Provider",
      YOU_SURE: "Are you sure to delete this provider?",
      ENABLE: "Enable",
      DISABLE: "Disable",
      BUILDIN_DESC:
        "The built-in Microsoft Office 365 Authentication Provider asks the users to grant the following permissions:",
      BUILDIN_RULE: "Sign in and read user profile - Microsoft Graph API",
      BUILTIN_CONFIG_DESC: "Built-in OAuth 2.0 Provider",
      CUSTOM_CONFIG_DESC: "Custom OAuth 2.0 Provider",
      CUSTOM_NOT_CONFIG_DESC: "Create your own OAuth 2.0 provider",
      CREATE_PROVIDER: "Create Provider"
    },
    DOCUMENT: {
      SERVICES: "Document Services"
    },
    TENENT: {
      ID: "Tenant ID"
    },
    PASSWORD: {
      CHANGE_PASSWORD: "Change Password",
      FAILED_CHANGE: "Failed to change password.",
      SUCCEED_CHANGE: "Password changed successfully.",
      CURRENT_PASSWORD: "Current Password",
      OLD_NEEDED: "The password entered is invalid.",
      NEW_NEEDED: "A new password is required.",
      NEW_PASSWORD: "New Password",
      CONFIRM: "Confirm Password",
      OLD_PASSWORD: "Old Password",
      INVALID_FORM:
        "Please enter a password that is between 8 and 32 characters and contains at least one uppercase, one lowercase, one numeric and one special character.",
      NO_MATCH: "The passwords entered do not match. Please try again.",
      OVER_SIZE: "Passwords must be at least 8 - 32 characters.",
      LITTLE_SIZE: "Passwords must be at least 8 characters in length.",
      OLD_NOT_MATCH: "The password entered is invalid."
    },
    APPLICATION: {
      DOCUMENT_SERVICE: "Document Service Configuration",
      FAILED_FIND: "Failed to find the application.",
      FAILED_SAVE: "Failed to save changes.",
      APPLICATION: "Application",
      FAILED_DELETE: "Failed to delete the application.",
      NO_APPLICATION: "No application found. Add an application.",
      FAILED_FETCH: "Failed to integrate the application.",
      YOU_SURE: "Are you sure to delete this service?",
      DEL_TITLE: "Delete Document Service"
    },
    LOGIN: {
      LOGIN_FAILED: "Sign in failed. Please check your email address.",
      LOGIN_NO_PERMISSION:
        "You are not a device administrator. Please change to another account or update your account to a device administrator.",
      EMAIL_INVALID: "Invalid email address.",
      SERVICE_UNAVAILABLE:
        "Service temporarily unavailable. Please try again later.",
      UNAUTHORIZED:
        "Unauthorized user. Please enter the email address of an authorized user.",
      NO_ACCOUNT: "No account?",
      CREATE_ONE: "Create one",
      MAXIMUM:
        "Sign in failed. You have exceeded the maximum number of sign-in attempts at this time. Please wait {{minute}} minutes and try again."
    },
    USER: {
      TITLE: "Users",
      NAME: "User Name",
      EMAIL: "Email Address",
      LANGUAGE: "User Language",
      STATUS: "User Status",
      ROLE: "User Role",
      FAILED_FETCH: "Failed to fetch users",
      NO_FOUND: "No user found.",
      FAILED_ADD: "Failed to add new user",
      FIRSTNAME: "First Name",
      LASTNAME: "Last Name",
      PERMISSIONS: "User Permission",
      FAILED_SAVE: "Failed to save changes.",
      SUCCEED_ADD: "Succeed to add the user.",
      SUCCEED_SAVE: "Succeed to save changes.",
      DELETE: "Delete User",
      FAILED_DELETE: "Failed to delete the user.",
      SUCCEED_DELETE: "Succeed to delete the user.",
      TOTAL: "Total Users",
      ACCOUNT: "Account",
      LOGOUT: "Sign Out",
      LOGGED_IN: "Cannot edit the user because the user has signed in.",
      DELETE_SURE: "Are you sure you want to delete this user?",
      NO_PERMISSION: "The user does not have the necessary permissions",
      IN_USER: "A user with that email address already exists.",
      BAD_REQUEST: "Bad request",
      INVALID: "Please check the email is valid for the tenant",
      FAILED_ACTIVE: "Failed to activate this user",
      ACTIVE: "Active",
      SURE_ACTIVE:
        "Are you sure you want to activate the local account for {{email}}?",
      ACTIVING: "Activating",
      INACTIVE: "Inactive",
      SURE_INACTIVE:
        "Are you sure you want to deactivate the local account for {{email}}?",
      INACTIVING: "Deactivating",
      WRONG_DOMAIN: "The email-domain does not match the current tenant",
      CHANGE_PROFILE: "Change Profile",
      DISPLAY_NAME: "Display Name",
      NEW_DISPLAY_NAME: "A new display name is required.",
      FAILED_CHANGE_PROFILE: "Failed to change my profile.",
      INVALID_EMAIL: "You entered an invalid email address.",
      INACTIVE_USER: "Deactivate User",
      ACTIVE_USER: "Activate User",
      LANGUAGE_TIP: "This setting is only used for email notifications.",
      FAILED_FIND: "Failed to find the users.",
      ADD_NEW: "Add New User",
      SIGN_IN_ACCOUNT: "Sign In Account",
      ENTERPRISE_ONLY: "Enterprise Only",
      ENTERPRISE_LOCAL: "Enterprise and Local",
      ACCOUNT_TIP: "Disabled due to no active authentication providers.",
      ACCOUNT_DETAIL: "Account Details",
      ACCOUNT_ID: "Polycom Cloud Service Account ID",
      USER: "User"
    },
    LOGS: {
      TITLE: "Activity Logs",
      FAILED_FETCH: "Failed to fetch logs.",
      NO_FOUND: "No logs found.",
      DATE_TIME: "Date Time",
      OPERATION: "Operation"
    },
    ROLE: {
      TITLE: "Role Management",
      NAME: "Role Name",
      DESCRIPTION: "Role Description",
      ROLE: "User Role",
      FAILED_FETCH: "Failed to fetch roles",
      NO_FOUND: "No role found.",
      FAILED_ADD: "Failed to add new role.",
      PERMISSIONS: "Role Permission",
      FAILED_SAVE: "Failed to save changes.",
      SUCCEED_ADD: "Succeed to add the role.",
      SUCCEED_SAVE: "Succeed to save changes.",
      DELETE: "Delete Role",
      FAILED_DELETE: "Failed to delete the role.",
      TOTAL: "Total Roles",
      DELETE_SURE: "Are you sure to delete this role?",
      NO_PERMISSION: "The user does not have the necessary permissions",
      BAD_REQUEST: "Bad request"
    },
    LANDING: {
      LEGACY_MANAGEMENT: "Voice Devices",
      CONTENT_MANAGEMENT: "Content Devices",
      INFRASTRUCTURE: "Infrastructure Devices",
      SYS_CONFIG: "System Configuration",
      OTD_MGT: "One Touch Dial Application",
      OTD: "One Touch Dial",
      FEDERATION: "Enterprise Federation",
      COMMUNITY: "Polycom Community",
      LICENSES: "Licenses",
      USERS: "Users",
      TWITTER: "Polycom at Twitter",
      FACEBOOK: "Polycom at Facebook",
      YOUTUBE: "Polycom at Youtube",
      LINKEDIN: "Polycom at LinkedIn",
      GOOGLE_P: "Polycom at Google+"
    },
    LICENSE: {
      MANAGEMENT: "Licenses",
      TITLE_NEW: "Activate New License",
      NO_FOUND: "No license found.",
      LICENSE_ID: "License ID",
      DESCRIPTION: "Description",
      TYPE: "Type",
      FEATURE_CODE: "Feature Code",
      TRANSACTION_TYPE: "Transaction Type",
      START_TIME: "Start Time",
      END_TIME: "End Time",
      QUANTITY: "Quantity",
      USED_TOTAL: "Used / Total",
      STATUS: "Status",
      SUMMARY: "Summary",
      TOTAL: "Total",
      OTD_DEVICE: "One Touch Dial Application",
      DETAILS: "Details",
      NEW_LICENSE: "Activate New License",
      ACTIVE: "Active",
      ACTIVATE: "Activate",
      DOING_ACTIVE: "Activating",
      ACTIVE_SIGNIN: "Create Account and Sign In",
      EXPIRED: "Expired",
      EXPIRING_SHORTLY: "Expiring Shortly",
      IMPENDING: "Impending",
      INACTIVE: "Inactive",
      WILL_EXPIRE: "{{no}} are expiring",
      ACCEPT_NOTE: "I agree to the ",
      ULA_TITLE: "Terms of Service",
      AND: "and",
      PRIVACY_POLICY: "Privacy Policy.",
      NOTE:
        "Enter or paste the License Activation Key from your Polycom user license document. The key is a 17-character string found at the top of your license document in a box as shown.{{tip}}",
      INVALID_FORMAT_KEY: "Please enter a valid key.",
      TITLE_PDMS: "Polycom Device Management Service Licenses",
      TITLE_OTD: "One Touch Dial Application License",
      ACTIVATE_DONE: "Activation successful.",
      ACTIVATE_FAIL_400: "Failed to activate the licenses.",
      ACTIVATE_FAIL_401: "You must login again to activate new license.",
      ACTIVATE_FAIL_404:
        "Failed to activate the licenses. The license key is invalid or missing.",
      ACTIVATE_FAIL_412:
        "Failed to activate the licenses. The activation key is already used.",
      ACTIVATE_FAIL_409:
        "Failed to activate the licenses. The activation key is already used.",
      ACTIVATE_FAIL_410:
        "Failed to activate the licenses. The activation key is inactive.",
      ACTIVATE_FAIL_500: "Failed to activate the licenses.",
      FAILED_FETCH: "Failed to fetch licenses.",
      INVALID_URL: "Failed to verify URL. Please check your link. ",
      INVALID_KEY_400:
        "This license activation key is invalid. Please check the key and try again.",
      INVALID_KEY_401: "You must login again to activate new license.",
      INVALID_KEY_404:
        "This license activation key is invalid or missing. Please check the key and try again.",
      INVALID_KEY_412:
        "This license activation key is already used. Please check the key and try again.",
      INVALID_KEY_410:
        "This license activation key is inactive. Please check the key and try again.",
      INVALID_KEY_500:
        "Failed to verify the code. Please check the key and try again."
    },
    ANALYTICS: {
      TITLE: "RealAccess",
      MENU: {
        TUTORIAL: "Tutorial Library",
        ASSETS: "Assets",
        CALLS: "Calls",
        CALL_SUMMARY: "Summary",
        DEVICE_DASHBOARD: "Device Dashboard"
      }
    }
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCALE_DATA_RECEIVED:
      return {
        translation: action.data,
        locale: action.locale
      };

    case GET_LOCALE_ERROR:
      return {
        ...state,
        err: action.err
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/localization.js